import { createContext } from 'react';

export const UsuarioContext = createContext(null);
export const SucursalesContext = createContext(null);
export const SucursalContext = createContext(null);